import script from "./BOTBChecker.vue?vue&type=script&setup=true&lang=js"
export * from "./BOTBChecker.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__